// @core/api/endpoints/calendar/create_event_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateEventTemplateRequest,
  EventTemplateResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Create event template
 * Creates a reusable event template with predefined title, description, attendees, location, and conference settings.
 */
export async function CreateEventTemplate(
  data: CreateEventTemplateRequest,
  options?: RequestOptions
): Promise<EventTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/event-templates`;
  const requestOptions = options;
  return client.post<EventTemplateResponse>(requestPath, data, requestOptions);
}
